module.exports = __webpack_public_path__ + "static/media/google-4-code.9370b537.png";